import classNames from 'classnames'
import React from 'react'

import {EditButton} from '../EditButton/EditButton'

import styles from './Actions.css'

import IconButton from 'src/components/common/IconButton/IconButton'

type Props = {
  className?: string
  iconClassName?: string
  onEditClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  editBtnTitle?: string
  onDeleteClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  deleteBtnTitle?: string
  onRestoreClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  restoreBtnTitle?: string
  onAddClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  addBtnTitle?: string
  disabled?: boolean
  deleted?: boolean
  hiddenDefault?: boolean
}

function Actions({
  className,
  iconClassName,
  deleted,
  disabled,
  onEditClick,
  onDeleteClick,
  onRestoreClick,
  onAddClick,
  hiddenDefault = true,
  addBtnTitle,
  editBtnTitle,
  deleteBtnTitle,
  restoreBtnTitle,
}: Props) {
  return (
    <div className={classNames(styles.actions, {[styles.hiddenDefault]: hiddenDefault}, className)}>
      {deleted ? (
        onRestoreClick && (
          <IconButton
            icon={'update'}
            title={restoreBtnTitle ?? 'Restore'}
            aria-label={restoreBtnTitle ?? 'Restore'}
            onClick={onRestoreClick}
            disabled={disabled}
          />
        )
      ) : (
        <>
          {onEditClick && (
            <EditButton
              title={editBtnTitle ?? 'Edit'}
              aria-label={editBtnTitle ?? 'Edit'}
              onClick={onEditClick}
              disabled={disabled}
            />
          )}
          {onDeleteClick && (
            <IconButton
              icon={'trash'}
              title={deleteBtnTitle ?? 'Delete'}
              aria-label={deleteBtnTitle ?? 'Delete'}
              onClick={onDeleteClick}
              disabled={disabled}
            />
          )}
          {onAddClick && (
            <IconButton
              className={styles.addButton}
              iconClassName={iconClassName}
              icon={'add'}
              title={addBtnTitle ?? 'Add'}
              aria-label={addBtnTitle ?? 'Add'}
              onClick={onAddClick}
              disabled={disabled}
            />
          )}
        </>
      )}
    </div>
  )
}

export default React.memo(Actions)
